<template>
  <div class="flex w-full gap-8 pb-6">
    <div class="w-1/4 space-y-1">
      <h3 class="font-semibold text-dark-neutral-500">Exclusion criteria</h3>
      <p class="text-sm text-gray-600 font-light">
        Set criteria for screening and excluding studies at different stages.
      </p>
    </div>
    <div class="w-full space-y-4">
      <TitleAndAbstractScreeing
        v-if="
          !review.isPlanReadonly.value ||
          titleAndAbstractScreeingCriteria.length > 0
        "
        class="w-full"
      />

      <FullTextScreeing class="w-full" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { injectStrict } from '@app/utils/injectStrict'
import { ReviewKey } from '@app/views/Review/use-review'
import { ref, watchEffect } from 'vue'
import TitleAndAbstractScreeing from './TitleAndAbstractScreeing.vue'
import FullTextScreeing from './FullTextScreeing.vue'

const review = injectStrict(ReviewKey)

const fullTextScreeingCriteria = ref<string[]>([])
const titleAndAbstractScreeingCriteria = ref<string[]>([])

watchEffect(() => {
  titleAndAbstractScreeingCriteria.value =
    review.entity.value?.plan?.screeningPlan?.titleAndAbstractCriteria ?? []

  fullTextScreeingCriteria.value =
    review.entity.value?.plan?.screeningPlan?.fullTextCriteria ?? []
})
</script>
